let myMixin = {
  methods: {
    getCookie: function (cookiename) {
      // Get name followed by anything except a semicolon
      let cookiestring = RegExp('' + cookiename + '[^;]+').exec(document.cookie)
      // Return everything after the equal sign
      if (cookiestring) {
        cookiestring = unescape(cookiestring.toString().replace(/^[^=]+./, ''))
      } else {
        cookiestring = false
      }

      return cookiestring
    },
    setCookie: function (name, value, days) {
      let date = new Date()
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000))
      let expires = '; expires=' + date.toUTCString()
      document.cookie = name + '=' + value + expires + '; path=/'
    }
  }
}

export default myMixin



// WEBPACK FOOTER //
// ./src/mixins.js